import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_CRYPTO_RATES_HISTORY = 'FETCH_CRYPTO_RATES_HISTORY'
export const RECEIVE_CRYPTO_RATES_HISTORY = 'RECEIVE_CRYPTO_RATES_HISTORY'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_CRYPTO_RATES_HISTORY,
	receive: RECEIVE_CRYPTO_RATES_HISTORY
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchCryptoRatesHistory = (filters, force) => fetch('cryptoRatesHistory', 'cryptorates', actionTypes, {}, filters, force)
